
module.exports = {
  brand: function(d) { return "THE OUTNET"; },
  contact: {
    title: function(d) { return "도움이 필요하신가요?"; },
    copyBeforeLink: function(d) { return "THE OUTNET"; },
    copyAfterLink: function(d) { return " 페이지를 방문해 보세요."; },
    href: function(d) { return "/page/help/returns/"; },
    customerCare: function(d) { return "고객 서비스"; }
  },
  search: {
    text: function(d) { return "THE OUTNET 검색"; },
    clear: function(d) { return "삭제"; },
    categories: function(d) { return "카테고리"; },
    designers: function(d) { return "디자이너"; },
    products: function(d) { return "상품"; },
    colours: function(d) { return "컬러"; },
    cta: function(d) { return "검색"; },
    noResult: function(d) { return d.searchTerm + "에 대한 검색 결과가 없습니다"; },
    tryAgain: function(d) { return "다시 시도하세요."; },
    loading: function(d) { return "검색 중"; },
    viewAll: function(d) { return "모든 결과 보기(" + d.count + ")"; }
  },
  price: {
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    discountPrice: function(d) { return "할인 가격"; },
    currencyExchange: function(d) { return "(Approx " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    wasPriceOriginal: function(d) { return "RRP: " + d.wasPrice; },
    wasPrice: function(d) { return "RRP:"; },
    originalPrice: function(d) { return "정가:"; }
  },
  localeSwitch: {
    languages: {
      en: function(d) { return "English"; },
      ar: function(d) { return "اللغة العربية"; },
      de: function(d) { return "Deutsch"; },
      fr: function(d) { return "française"; },
      ja: function(d) { return "日本語"; },
      ko: function(d) { return "한국어"; }
    },
    changeCountry: {
      title: function(d) { return "국가/지역 변경"; },
      description: function(d) { return "THE OUTNET을 최대한 잘 활용하려면 아래 목록에서 고객님의 국가/지역을 선택해주세요."; }
    },
    itemsUnavailable: {
      title: function(d) { return "아이템 구매 불가"; },
      description: function(d) { return "죄송합니다. 해당 국가에서는 쇼핑백에 있는 아이템 중 한 개 이상을 구매하실 수 없습니다. 국가를 변경하는 경우 해당 아이템이 쇼핑백에서 삭제됩니다."; },
      confirmation: function(d) { return "국가 변경 확인"; },
      addToWishlist: function(d) { return "아이템을 위시리스트에 추가"; }
    }
  },
  cookieBanner: {
    title: function(d) { return "쿠키 및 개인정보"; },
    message: function(d) { return "당사 웹사이트를 계속 이용함으로써 귀하는 웹사이트의 기능 보장, 표시된 콘텐츠의 맞춤화, 당사가 제공하는 상품 및 서비스 개선을 목적으로 한 통계 및 분석 연구 수행을 위해 쿠키를 사용하는 데 동의하게 됩니다. 브라우저 설정에서 쿠키를 차단하거나 삭제할 수 있습니다. 쿠키 사용에 대한 자세한 내용은 다음 섹션을 참조하십시오."; },
    cta: function(d) { return "\"Cookie Policy\"."; },
    href: function(d) { return "/page/help/cookie-policy"; }
  },
  nav: {
    myAccount: {
      text: function(d) { return "안녕하세요, " + d.name + "님"; },
      href: function(d) { return "/account"; }
    },
    myAccountMobile: {
      text: function(d) { return "내 계정"; }
    },
    signIn: {
      text: function(d) { return "로그인"; },
      href: function(d) { return "/account/login"; }
    },
    signOut: {
      text: function(d) { return "로그아웃"; },
      href: function(d) { return "/account/login"; }
    },
    account: {
      text: function(d) { return "내 계정"; },
      href: function(d) { return "/account"; }
    },
    wishlist: {
      text: function(d) { return "위시리스트"; },
      href: function(d) { return "/account/wishlist"; }
    },
    checkout: {
      text: function(d) { return "결제"; },
      href: function(d) { return "/checkout"; }
    },
    register: {
      text: function(d) { return "가입"; },
      href: function(d) { return "/account/login"; }
    }
  },
  courtesyNav: {
    customerServiceInfo: {
      text: function(d) { return "고객 서비스"; },
      href: function(d) { return "/page/help/contact-us"; }
    },
    deliveryInfo: {
      text: function(d) { return "배송"; },
      href: function(d) { return "/page/help/customer-service/delivery"; }
    },
    returnsInfo: {
      text: function(d) { return "반품"; },
      href: function(d) { return "/page/help/customer-service/returns"; }
    },
    myOrders: {
      text: function(d) { return "주문 조회"; },
      href: function(d) { return "/account/orders"; }
    },
    trackOrder: {
      text: function(d) { return "주문 조회"; },
      href: function(d) { return "/account/track-order"; }
    },
    createReturn: {
      text: function(d) { return "반품 신청"; },
      href: function(d) { return "/account/create-return"; }
    }
  },
  copyright: {
    yearFrom: function(d) { return "2009 - "; },
    copy: function(d) { return ", YOOX NET-A-PORTER GROUP 소속."; },
    extraCopy: function(d) { return "본 사이트에 등장하는 개인은 THE OUTNET 또는 표시되는 상품을 보증하지 않습니다."; }
  },
  social: {
    title: function(d) { return "소셜 미디어"; }
  },
  externalLinks: {
    mrp: function(d) { return "https://www.mrporter.com/"; },
    nap: function(d) { return "https://www.net-a-porter.com/"; }
  },
  error: {
    megaNav: function(d) { return "죄송합니다. 해당 메뉴를 찾을 수 없습니다."; }
  },
  checkout: {
    copy: function(d) { return "안전 결제"; }
  },
  footer: {
    footerLinks: function(d) { return "정보 및 도움말"; },
    contactAndLocale: function(d) { return "연중무휴 고객센터"; },
    signupAndSocial: function(d) { return "소셜로 연결"; }
  },
  fastUserRegistration: {
    heading: function(d) { return "언제나 스타일리시함을 유지하고 싶으신가요?"; },
    description: function(d) { return "THE OUTNET 뉴스레터를 구독하여 다음 주문 시 15% 추가 할인 혜택을 받으세요! 또한 독점 신상품, 최신 트렌드, 예정된 프로모션 소식을 가장 먼저 만나볼 수 있습니다. "; },
    exclusionsText: function(d) { return "일부 상품 제외 - 이용 약관 보기"; },
    exclusionsLink: function(d) { return "https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes"; },
    subscribe: function(d) { return "구독 신청"; },
    placeholder: function(d) { return "이메일 주소를 입력하세요."; },
    sucessfulEmailMessage: function(d) { return "감사합니다. 뉴스레터 구독 신청이 완료되었습니다!"; },
    NoEmailMessage: function(d) { return "이메일 주소를 입력하세요."; },
    invalidEmailMessage: function(d) { return "유효하지 않은 이메일 주소"; }
  },
  seoMeta: {
    title: function(d) { return "디자이너 패션 최대 70% 할인 | 세일 - THE OUTNET"; },
    description: function(d) { return "350여 개 럭셔리 디자이너 패션 브랜드를 파격적인 가격에 제공하는 더 아웃넷(THE OUTNET)에서 스타일을 업그레이드해 줄 아이템을 쇼핑하세요!"; }
  },
  webpush: {
    title: function(d) { return "최신 프로모션 및 할인 소식을 가장 먼저 듣고 싶으신가요?"; },
    description: function(d) { return "소식을 놓치지 않도록 알림을 보내드립니다!"; },
    toggleMessage: function(d) { return "푸시 알림 받기"; }
  },
  multishop: {
    mens: function(d) { return "남성"; },
    womens: function(d) { return "여성"; }
  },
  promptBasketItem: {
    title: function(d) { return "아이템이 쇼핑백에 추가되었습니다"; },
    button: function(d) { return "쇼핑백 확인하기"; }
  }
}